var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftPurview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1549 23.473C25.7971 23.473 23.8848 21.5626 23.8819 19.2048C21.0029 19.2365 18.6941 21.5971 18.7258 24.4762C18.7574 27.3552 21.1181 29.664 23.9971 29.6323C26.8762 29.6006 29.185 27.24 29.1533 24.361C29.1494 24.0298 29.1149 23.7005 29.0486 23.376C28.7549 23.4394 28.4554 23.472 28.1549 23.473Z",
    fill: "url(#paint0_linear_3334_2923)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.175 29.8781C33.984 27.9984 33.3946 26.1802 32.447 24.5453C32.1715 29.0102 28.4746 32.4941 24 32.5018C23.7974 32.5018 23.6074 32.4566 23.4096 32.4413C18.9312 32.3827 14.64 30.6317 11.3981 27.5405C8.6112 24.863 6.54432 21.5251 5.38848 17.8368C3.86304 19.223 2.4192 20.6957 1.06272 22.247C0.0911955 23.1466 0.0316754 24.6634 0.931195 25.6349C0.973435 25.681 1.0176 25.7242 1.06272 25.7664C3.97824 29.2627 7.41407 32.2915 11.2483 34.7453C15.1046 37.3882 19.6704 38.8032 24.3456 38.8051C27.384 38.8224 30.3821 38.1091 33.0874 36.7267C33.2582 36.648 33.4061 36.5424 33.575 36.4637C34.1741 34.3238 34.3776 32.0909 34.175 29.8781Z",
    fill: "url(#paint1_linear_3334_2923)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.512 27.9523C14.713 24.6394 15.3504 20.5334 18.0691 17.9222C20.2051 15.047 23.1984 12.9254 26.6189 11.8627C28.4832 11.2934 30.4186 10.9882 32.3674 10.9565C30.7987 10.2768 29.1571 9.78144 27.4752 9.48096C22.8682 8.70528 18.1334 9.48672 14.0198 11.7024C11.7187 12.8966 9.54624 14.3251 7.53888 15.9658C8.4864 19.583 10.3987 22.8749 13.0714 25.4899C14.1024 26.4605 15.2602 27.289 16.512 27.9523Z",
    fill: "url(#paint2_linear_3334_2923)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0006 22.3642C44.4259 19.2797 41.4528 16.5523 38.159 14.2522C34.7145 13.3114 31.079 13.3296 27.6441 14.305C26.6131 14.6198 25.6157 15.0422 24.6749 15.5693C26.1465 15.673 27.5654 16.1597 28.7904 16.9814C28.8998 17.0131 29.0054 17.0602 29.1014 17.1206C33.1997 19.873 35.9616 24.2141 36.7181 29.0928C36.959 30.9859 36.9293 32.9021 36.6307 34.7866C40.535 32.305 44.0294 29.233 46.9901 25.6781C47.9078 24.8237 47.9597 23.3866 47.1043 22.4688C47.0707 22.4323 47.0361 22.3978 47.0006 22.3642Z",
    fill: "url(#paint3_linear_3334_2923)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3334_2923",
    x1: 23.9395,
    y1: 29.6326,
    x2: 23.9395,
    y2: 19.2048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29BADE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#50E6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3334_2923",
    x1: 17.2722,
    y1: 38.8054,
    x2: 17.2722,
    y2: 9.16014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#32BEDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#50E6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#C3F1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3334_2923",
    x1: 19.9531,
    y1: 26.7585,
    x2: 19.9531,
    y2: 0.957202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.244,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2E8CE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#589EED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3334_2923",
    x1: 36.1942,
    y1: 38.8226,
    x2: 36.1942,
    y2: 11.3352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.857,
    stopColor: "#5EA0EF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftPurview);
export default __webpack_public_path__ + "static/media/Microsoft_purview.bd1599219b5ecc0017db49bc62022e48.svg";
export { ForwardRef as ReactComponent };